"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dsl = exports.route = exports.method = void 0;
function method(_fn_) {
    // Explain that this is done in build-time
    return { fileName: '', functionName: '', __fn__: _fn_ };
}
exports.method = method;
function route(_route_) {
    return _route_;
}
exports.route = route;
function dsl(_dsl_) {
    return _dsl_;
}
exports.dsl = dsl;
//# sourceMappingURL=wrap.js.map